// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/api/keys',
    name: 'api-keys-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/configuration/ApiKeys.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'api_keys',
    },
  },
]

export default formTable
